export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DetailHeader.vue?vue&type=style&index=0&id=8892161e&prod&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/DetailHeader.vue?vue&type=style&index=0&id=8892161e&prod&scoped=true&lang=css&
// module id = 1572
// module chunks = 0